module.exports = __webpack_public_path__ + "img/timeQuantum.552a82bc.png";